import SubscriptionsTableContainer from './SubscriptionsTableContainer';
import SubscriptionListData from "./services/SubscriptionListData";
import DeleteSubscriptionData from "./services/DeleteSubscriptionData";
import stores from './stores';

const SubscriptionsTable = {
  path: [`/subscriptions`],
  exact: true,
  services: [new SubscriptionListData(), new DeleteSubscriptionData()],
  stores: stores,
  component: SubscriptionsTableContainer,
};

export default SubscriptionsTable;